interface ProjectTypeProps {
  type: string;
  placeholdersHidden: boolean;
}

export default function ProjectType({
  type,
  placeholdersHidden,
}: ProjectTypeProps) {
  return (
    <>
      {placeholdersHidden === false || type ? (
        <div
          className={`${
            placeholdersHidden ? "text-gray-500" : "skeleton-text"
          }`}
        >
          {placeholdersHidden ? type : "Project Type"}
        </div>
      ) : (
        <div className={`mb-0.5`}>{type}</div>
      )}
    </>
  );
}
